const ApiService = Shopware.Classes.ApiService;

/**
 * Gateway for the API end point
 * @class
 * @extends ApiService
 */
class PremsPremiumItemApiService extends ApiService {
    constructor(httpClient, loginService, apiEndpoint = 'prems-premium-item') {
        super(httpClient, loginService, apiEndpoint);
    }

    getMaxPremiumItemLimitReached(additionalHeaders = {}) {
        const headers = this.getBasicHeaders(additionalHeaders);

        return this.httpClient.post(
            `_action/${this.getApiBasePath()}/get-max-number-premium-item-limit-reached`,
            {  },
            { headers }
        ).then(response => response.data);
    }
}

export default PremsPremiumItemApiService;
